module.exports = __webpack_public_path__ + "af30eae2322d133b9188fe4fb63d07e1.svg";